import { v4 as uuidv4 } from 'uuid';

export async function nextPage() {
    if (this.loadingMoreSubscriptions) return;

    const requestedPage = this.page.number + 1;

    this.loadingMoreSubscriptions = true;
    this.observed.loadingMoreSubscriptions = uuidv4();

    this.page.number = requestedPage;
    await this.getSubscriptions({ silent: true });

    // Roll back if the fetch failed, so a retry doesn't skip this page.
    if (this.pageInfo.currentPage !== requestedPage) {
        this.page.number = requestedPage - 1;
    }

    this.loadingMoreSubscriptions = false;
    this.observed.loadingMoreSubscriptions = uuidv4();
}
